import { render, staticRenderFns } from "./card-note.vue?vue&type=template&id=0fb133fd&scoped=true"
import script from "./card-note.vue?vue&type=script&lang=js"
export * from "./card-note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb133fd",
  null
  
)

export default component.exports